export default __webpack_public_path__ + "static/anastasiia-ostapovych-IMm3o-Kfkf8-unsplash-bd81c0ae8c6356f065c342ae9c74aa31.jpg";